import React from 'react'
import './layout.css';

function TopNavigation() {
  return (
    <div className="navigation-block d-flex justify-content-between align-items-center p-2 border-bottom">
            <div className="left-nav-block">
                <div className="welcome-box">
                    <h4>Welcome  </h4>
                </div>
            </div>
            <div className="right-nav-block d-flex align-items-center">
                <div className="notification-block">
                    <i className="bi bi-bell fs-4"></i>
                </div>
                <div className="profile-item">
                    <div className="img-prof-item me-2 rounded-circle bg-secondary"></div>
                    <div className="drop-view-content dropdown">
                         <div className="profile-item-names">
                          
                         </div>
                        
                    </div>
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li><a className="dropdown-item" href="#">Profile</a></li>
                        <li><a className="dropdown-item" href="#">Inbox</a></li>
                        <li><a className="dropdown-item" href="#">Settings</a></li>
                        <li><hr className="dropdown-divider"/></li>
                        <li><a className="dropdown-item text-danger" href="#">Logout</a></li>
                    </ul>
                </div>
            </div>
        </div>
  )
}

export default TopNavigation